import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PhoneComponent, SdModalService, SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { ButtonThemes } from '@shared/v2';
import { CitiesDialogComponent } from '../cities-dialog';

@Component({
  selector: 'sd-cities-no-delivery-container',
  imports: [SdvorButtonComponent, PhoneComponent],
  templateUrl: './cities-no-delivery-container.component.html',
  styleUrls: ['./cities-no-delivery-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitiesNoDeliveryContainerComponent {
  buttonThemes = ButtonThemes;

  constructor(private modalService: SdModalService) {}

  changeCities(e: MouseEvent): void {
    e.preventDefault();
    this.modalService.open(CitiesDialogComponent, {
      modalType: { xxs: 'fullscreen', lg: 'standard' },
      maxWidth: { lg: '812px' },
    });
  }
}
